"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[47991],{

/***/ 898815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ MegaMenu; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(472522);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(788925);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MegaMenu = ({
  type,
  align = "left",
  menuItems
}) => {
  const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0);
  const verticalMenuWidth = "12.375rem";
  const horizontalMenuHeight = "3rem";
  const megaMenuHeight = "28.5rem";
  if (!menuItems.length)
    return null;
  const hideMenuPanel = () => {
    setActiveMenu(void 0);
  };
  const renderVerticalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      className: "vertical-mega-menu-wrapper",
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMegaMenu, {
      className: `vertical-mega-menu ${activeMenu ? "active" : ""}`,
      width: verticalMenuWidth,
      height: megaMenuHeight
    }, menuItems.slice(0, _MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__/* .MAX_MENU_ITEMS */ .K).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItem, {
      className: "vertical-mega-menu-item",
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuItemImageMegaMenuWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_3__/* .EnhancedImage */ .N, {
      src: item.icon,
      height: "100%"
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Caption */ .YS, {
      level: 2,
      line: 1,
      style: { flex: 1 }
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(VerticalMenuPanel, {
      className: `vertical-mega-menu-panel ${activeMenu ? "active" : ""}`,
      type,
      verticalMenuWidth,
      menu: menuItems,
      activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  const renderHorizontalMegaMenu = () => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuWrapper, {
      onMouseLeave: hideMenuPanel
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMegaMenu, {
      height: horizontalMenuHeight,
      align
    }, menuItems.slice(0, 14).map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, item.link), {
      key: index
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuItem, {
      height: horizontalMenuHeight,
      onMouseEnter: () => {
        setActiveMenu(item);
      }
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
      level: 2,
      line: 1,
      hoverColor: "primary500"
    }, item.name))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HorizontalMenuPanel, {
      type,
      className: activeMenu ? "active" : "",
      horizontalMenuHeight,
      menu: menuItems,
      activeMenu,
      onClickMenuItem: hideMenuPanel
    }));
  };
  if (type === "vertical")
    return renderVerticalMegaMenu();
  return renderHorizontalMegaMenu();
};
const MegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  position: relative;
`;
const VerticalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__/* .MenuPanel */ .G)(({
  verticalMenuWidth,
  theme
}) => `
  position: absolute;
  top: 0;
  width: calc(75rem - ${verticalMenuWidth});
  left: ${verticalMenuWidth};
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.2s;
  visibility: hidden;
  opacity: 0;
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`);
const HorizontalMenuPanel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_MenuPanel_es_js__WEBPACK_IMPORTED_MODULE_1__/* .MenuPanel */ .G)(({
  horizontalMenuHeight,
  theme
}) => `
  position: absolute;
  left: 0;
  right: 0;
  top: ${horizontalMenuHeight};
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s;
  border-bottom-right-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  border-bottom-left-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05));
  }
`);
const VerticalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme, width, height }) => `
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  position: relative;
  overflow: hidden;
  width: ${width};
  height: ${height};
  z-index: 980;
  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`);
const HorizontalMegaMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme, height, align }) => `
  height: ${height};
  background-color: ${theme == null ? void 0 : theme.colors.white};
  width: 100%;
  overflow: hidden;
  ${align === "right" ? `display: flex;
        justify-content: flex-end;` : align === "space-between" ? `display: flex;
        justify-content: space-between;` : ""}
`);
const VerticalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme }) => `
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: ${theme == null ? void 0 : theme.spacing.s8};
  padding: 0 ${theme == null ? void 0 : theme.spacing.s8};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  overflow: hidden;
  &:hover {
    background-color: ${theme == null ? void 0 : theme.colors.primary50};
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const HorizontalMenuItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ theme, height }) => `
  padding: 0 ${theme == null ? void 0 : theme.spacing.s12};
  height: ${height};
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  &::after {
    content: '';
    height: 2px;
    background-color: ${theme == null ? void 0 : theme.colors.primary500};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s ease;
  }
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
    &::after {
      opacity: 1;
    }
  }
`);
const VerticalMenuItemImageMegaMenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  width: 22px;
  height: 22px;
`;




/***/ }),

/***/ 472522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ MenuPanel; },
/* harmony export */   "K": function() { return /* binding */ MAX_MENU_ITEMS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);
/* harmony import */ var _helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(369985);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(675601);
/* harmony import */ var _EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(788925);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MEGA_MENU_BANNER_WIDTH = "14.625rem";
const MAX_MENU_ITEMS = 15;
const MenuPanel = ({
  menu,
  activeMenu,
  className,
  type,
  onClickMenuItem
}) => {
  var _a, _b, _c, _d;
  if (!menu.length)
    return null;
  const col = (item) => {
    return item.map((it, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuLv2, {
      key: it.name + `-${index}`,
      onClick: onClickMenuItem
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadValues({}, it.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
      level: 1,
      line: 1,
      color: "primary500",
      marginBottom: "s8"
    }, it.name)), it.children.map((subItem, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadProps(__spreadValues({}, subItem.link), {
      key: index2
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, subItem.name)))));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuPanelWrapper, {
    isDisplay: !!activeMenu && (!!((_a = activeMenu.banner) == null ? void 0 : _a.src) || !!((_b = activeMenu.children) == null ? void 0 : _b.length)),
    className
  }, menu.slice(0, MAX_MENU_ITEMS).map((menuItem, index) => {
    const getMenuColumns = () => {
      var _a2;
      let totalCols = 6;
      if (type === "vertical")
        totalCols--;
      if ((_a2 = menuItem == null ? void 0 : menuItem.banner) == null ? void 0 : _a2.src)
        totalCols--;
      return totalCols;
    };
    const newMenu = (0,_helpers_megaMenu_es_js__WEBPACK_IMPORTED_MODULE_3__/* .convertMegaMenu */ .R)(menuItem, getMenuColumns());
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuItemsWrapper, __spreadValues({
      key: index,
      isActive: menuItem === activeMenu
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      regionName: "megaMenuText",
      isTrackContent: true
    })), newMenu.map((menu2, index2) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Column, {
      key: index2
    }, col(menu2.column))));
  }), ((_c = activeMenu == null ? void 0 : activeMenu.banner) == null ? void 0 : _c.src) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_1__/* .TekoLink */ .A, __spreadValues({}, (_d = activeMenu.banner) == null ? void 0 : _d.link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_EnhancedImage_EnhancedImage_es_js__WEBPACK_IMPORTED_MODULE_5__/* .EnhancedImage */ .N, {
    src: activeMenu.banner.src,
    width: MEGA_MENU_BANNER_WIDTH,
    height: "100%",
    googleImageParams: {
      width: 400
    },
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      regionName: "megaMenuBanner",
      isTrackContent: true
    })
  })));
};
const Text = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  margin-bottom: 4px;
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const MenuPanelWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme, isDisplay }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  display: ${isDisplay ? "flex" : "none"};
`);
const MenuItemsWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme, isActive }) => `
  display: ${isActive ? "flex" : "none"};
  flex: 1;
  padding: ${theme == null ? void 0 : theme.spacing.s12};
`);
const MenuLv2 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  margin-bottom: 1.5rem;
`;
const Column = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div`
  width: 25%;
  padding: 0 8px;
`;




/***/ }),

/***/ 675601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: (typeof href === "string" ? href : href == null ? void 0 : href.pathname) || "",
    query: {},
    as
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as, setNewState]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  if (serverless) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href: href || "",
    as
  }, rest), {
    prefetch
  }), children);
};
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
  color: black;
  text-decoration: none;
`;




/***/ }),

/***/ 369985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ convertMegaMenu; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const convertMegaMenu = (menu, numberCol) => {
  if (numberCol < 1)
    return [];
  const newArr = menu.children.map((m) => {
    return {
      len: m.children.length + 1,
      column: [__spreadValues({}, m)]
    };
  });
  if (newArr.length <= numberCol)
    return newArr;
  newArr.sort((a, b) => b.len - a.len);
  const result = [...newArr.slice(0, numberCol)];
  let min;
  let k;
  for (let i = numberCol; i < newArr.length; i++) {
    min = result[0].len;
    k = 0;
    for (let j = 0; j < numberCol; j++) {
      if (min > result[j].len) {
        min = result[j].len;
        k = j;
      }
    }
    result[k] = {
      len: result[k].len + newArr[i].len,
      column: [...result[k].column, ...newArr[i].column]
    };
  }
  return result;
};




/***/ }),

/***/ 339559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BannerSlides": function() { return /* binding */ BannerSlides; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(816519);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(788925);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(428247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788813);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  .glide__bullets--override {\n    bottom: 7em;\n  }\n\n  .glide__bullet--active {\n    background-color: ",
        ";\n  }\n\n  .glide__slide a {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const serverless = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServerless */ .ep)();
const BannerSlides = (param)=>{
    let { banners , imageWidth =1920 , imageHeight =566 , sliderRef , prioritized , showControl =false , displayNewLayout  } = param;
    if (!banners.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledGlide, {
        ref: sliderRef,
        perView: 1,
        autoplay: 3000,
        type: "carousel",
        showControl: showControl,
        displayNewLayout: displayNewLayout,
        showBullet: true,
        children: banners.map((banner, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SlideWrapper, _objectSpreadProps(_objectSpread({
                className: "glide__slide"
            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
                isTrackContent: true,
                regionName: "topSliderBannerHomepage",
                contentName: banner.campaignName,
                target: banner.targetPath,
                index
            })), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .EnhancedImage */ .N, {
                    googleImageParams: {
                        width: imageWidth
                    },
                    link: {
                        href: serverless && banner.targetPath && banner.targetPath.startsWith(location.origin) ? banner.targetPath.replace(location.origin, "") : banner.targetPath
                    },
                    objectFit: "cover",
                    width: "100%",
                    height: imageHeight || 566,
                    src: banner.image,
                    thumbnail: banner.thumbnail,
                    alt: banner.campaignName,
                    lazy: index === 0 ? false : true,
                    fetchPriority: index === 0 ? prioritized ? "high" : "auto" : "low"
                })
            }), index))
    });
};
const StyledGlide = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Glide */ .A)(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
});
const SlideWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject1());


/***/ }),

/***/ 847991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DefaultHome": function() { return /* binding */ DefaultHome; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/types.es.js
var types_es = __webpack_require__(875663);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ./components/desktop/organisms/DiscoveryBlocks.tsx
var DiscoveryBlocks = __webpack_require__(957663);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./helpers/block.ts
var block = __webpack_require__(997441);
// EXTERNAL MODULE: ./hooks/useHomePage.tsx
var useHomePage = __webpack_require__(439950);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./hooks/banners.ts
var banners = __webpack_require__(700074);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
;// CONCATENATED MODULE: ./modules/home/desktop/components/SideBanners.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 96px;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  min-width: 1264px;\n  z-index: -1;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 150px;\n  height: 350px;\n  z-index: 1040;\n  @media (max-width: 1600px) {\n    width: 60px;\n    height: 140px;\n  }\n  @media (max-width: 1366px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  object-fit: fill;\n  width: 100%;\n  transition: transform 0.4s;\n  &:hover {\n    transform: scale(1.05);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





const Parent = emotion_styled_browser_esm["default"].div(_templateObject());
const Wrapper = emotion_styled_browser_esm["default"].div(_templateObject1());
const Middle = emotion_styled_browser_esm["default"].div(_templateObject2());
const Banner = emotion_styled_browser_esm["default"].div(_templateObject3());
const StyledImg = emotion_styled_browser_esm["default"].img(_templateObject4());
const SideBanners = (param)=>{
    let { className  } = param;
    const { banners: responseRightBanners  } = (0,banners/* useBanners */.U)("right-sticky-banner-150x350");
    const { banners: responseLeftBanners  } = (0,banners/* useBanners */.U)("sticky-banner-150x350");
    const leftBanner = responseLeftBanners === null || responseLeftBanners === void 0 ? void 0 : responseLeftBanners[0];
    const rightBanner = responseRightBanners === null || responseRightBanners === void 0 ? void 0 : responseRightBanners[0];
    if (!leftBanner && !rightBanner) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Parent, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, _objectSpreadProps(_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                    regionName: "leftStickBanner",
                    isTrackContent: true
                })), {
                    children: leftBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: leftBanner.targetPath,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImg, {
                            src: leftBanner.image
                        })
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Middle, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, _objectSpreadProps(_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
                    regionName: "rightStickBanner",
                    isTrackContent: true
                })), {
                    children: rightBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: rightBanner.targetPath,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImg, {
                            src: rightBanner.image
                        })
                    })
                }))
            ]
        })
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/MegaMenu/MegaMenu.es.js
var MegaMenu_es = __webpack_require__(898815);
// EXTERNAL MODULE: ./components/desktop/organisms/BannerSlides.tsx
var BannerSlides = __webpack_require__(339559);
;// CONCATENATED MODULE: ./modules/home/desktop/components/NewAboveTheFold.tsx
function NewAboveTheFold_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NewAboveTheFold_templateObject() {
    const data = NewAboveTheFold_taggedTemplateLiteral([
        "\n  .vertical-mega-menu {\n    width: ",
        "px;\n    height: ",
        "px;\n  }\n  .vertical-mega-menu-panel {\n    width: calc(75rem - ",
        "px);\n    left: ",
        "px;\n  }\n  .vertical-mega-menu-item {\n    height: 28px;\n  }\n"
    ]);
    NewAboveTheFold_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewAboveTheFold_templateObject1() {
    const data = NewAboveTheFold_taggedTemplateLiteral([
        "\n  .glide__track {\n    max-width: 100% !important;\n    border-radius: 12px;\n  }\n  .glide__bullets--override {\n    bottom: 1rem !important;\n  }\n"
    ]);
    NewAboveTheFold_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const FeaturedBanners = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(6043), __webpack_require__.e(59530), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(4936)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.FeaturedBanners), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const EnhancedImage = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(6043), __webpack_require__.e(59530), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(4936)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.EnhancedImage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const ABOVE_THE_FOLD_MAX_WIDTH = 1232;
const ABOVE_THE_FOLD_HEIGHT = 424;
const MEGA_MENU_COL_WIDTH = (ABOVE_THE_FOLD_MAX_WIDTH - 32) / 6 - 16;
const SLIDE_BANNERS_HEIGHT = 280;
const NewLayoutAboveTheFold = (props)=>{
    const { menuItems , slideBanners , horizontalFourBanners , topRightBanners  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
        height: ABOVE_THE_FOLD_HEIGHT,
        marginBottom: "s24",
        marginTop: "s16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMegaMenuCol, {
                    span: 2,
                    paddingRight: "s16",
                    children: !!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
                        menuItems: menuItems,
                        type: "vertical"
                    }) : null
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                    span: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WideThickWrapper, {
                            maxHeight: (ABOVE_THE_FOLD_MAX_WIDTH - 32) / 3 * 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSlides.BannerSlides, {
                                imageWidth: (ABOVE_THE_FOLD_MAX_WIDTH - 32) / 3 * 2,
                                imageHeight: SLIDE_BANNERS_HEIGHT,
                                banners: slideBanners,
                                prioritized: true,
                                showControl: true,
                                displayNewLayout: true
                            })
                        }),
                        !!horizontalFourBanners.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                            marginTop: "s12",
                            maxHeight: ABOVE_THE_FOLD_HEIGHT - SLIDE_BANNERS_HEIGHT - 16,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                span: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBanners, {
                                    prioritized: true,
                                    regionName: "bottomBanner",
                                    banners: horizontalFourBanners.map((banner)=>{
                                        return {
                                            src: banner.image,
                                            link: {
                                                href: banner.targetPath
                                            },
                                            name: banner.campaignName,
                                            lazy: false,
                                            height: ABOVE_THE_FOLD_HEIGHT - SLIDE_BANNERS_HEIGHT - 16
                                        };
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                    span: 2,
                    paddingLeft: "s16",
                    children: topRightBanners.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        direction: "column",
                        gap: "s12",
                        children: topRightBanners.map((banner, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(EnhancedImage, {
                                link: {
                                    href: banner.targetPath
                                },
                                tracking: (0,helper_es/* getTrackingData */.O5)({
                                    isTrackContent: true,
                                    regionName: "topRightBannerHomepage",
                                    contentName: banner.campaignName,
                                    index: index,
                                    target: banner.targetPath
                                }),
                                src: banner.image,
                                borderRadius: 8,
                                height: (ABOVE_THE_FOLD_HEIGHT - 16) / 2,
                                objectFit: "cover",
                                googleImageParams: {
                                    width: (ABOVE_THE_FOLD_MAX_WIDTH - 32) / 6 - 16
                                },
                                width: (ABOVE_THE_FOLD_MAX_WIDTH - 32) / 6 - 16,
                                hover: "zoom",
                                alt: banner.campaignName || banner.description || "",
                                lazy: false,
                                fetchPriority: "high"
                            }, index))
                    })
                })
            ]
        })
    });
};
const StyledMegaMenuCol = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)(NewAboveTheFold_templateObject(), MEGA_MENU_COL_WIDTH, ABOVE_THE_FOLD_HEIGHT, MEGA_MENU_COL_WIDTH, MEGA_MENU_COL_WIDTH);
const WideThickWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(NewAboveTheFold_templateObject1());

;// CONCATENATED MODULE: ./modules/home/desktop/components/Next.svg
/* harmony default export */ var Next = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNMCAyNEMwIDEwLjc0NTIgMTAuNzQ1MiAwIDI0IDBINDhWNDhIMjRDMTAuNzQ1MiA0OCAwIDM3LjI1NDggMCAyNFoiIGZpbGw9IiMxQjFEMjkiLz4KPHBhdGggZD0iTTIxLjUgMzBMMjcuNSAyNEwyMS41IDE4IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=");
;// CONCATENATED MODULE: ./modules/home/desktop/components/Previous.svg
/* harmony default export */ var Previous = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNMCAwSDI0QzM3LjI1NDggMCA0OCAxMC43NDUyIDQ4IDI0QzQ4IDM3LjI1NDggMzcuMjU0OCA0OCAyNCA0OEgwVjBaIiBmaWxsPSIjMUIxRDI5Ii8+CjxwYXRoIGQ9Ik0yNi41IDE4TDIwLjUgMjRMMjYuNSAzMCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K");
;// CONCATENATED MODULE: ./modules/home/desktop/components/AboveTheFold.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ function AboveTheFold_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AboveTheFold_templateObject() {
    const data = AboveTheFold_taggedTemplateLiteral([
        "\n  position: relative;\n  content-visibility: auto;\n  margin-bottom: 24px;\n  .swiper-pagination {\n    bottom: 6rem !important;\n  }\n  min-height: 600px;\n  @media screen and (max-width: ",
        "px) {\n    height: auto;\n  }\n"
    ]);
    AboveTheFold_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AboveTheFold_templateObject1() {
    const data = AboveTheFold_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 0;\n"
    ]);
    AboveTheFold_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AboveTheFold_templateObject2() {
    const data = AboveTheFold_taggedTemplateLiteral([
        "\n  margin-top: -72px;\n"
    ]);
    AboveTheFold_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AboveTheFold_templateObject3() {
    const data = AboveTheFold_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    AboveTheFold_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









const AboveTheFold_EnhancedImage = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(6043), __webpack_require__.e(59530), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(4936)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.EnhancedImage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const AboveTheFold_FeaturedBanners = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(27953), __webpack_require__.e(20493), __webpack_require__.e(91592), __webpack_require__.e(81633), __webpack_require__.e(6043), __webpack_require__.e(59530), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(4936)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.FeaturedBanners), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const sliderHeight = 566;
const maxWidth = 767;
const AboveTheFold_Wrapper = emotion_styled_browser_esm["default"].div(AboveTheFold_templateObject(), maxWidth);
AboveTheFold_Wrapper.displayName = "AboveTheFold";
const StyledBannerSlides = emotion_styled_browser_esm["default"].div(AboveTheFold_templateObject1());
const FourBannerWrapper = (0,emotion_styled_browser_esm["default"])(Row_es/* Row */.X)(AboveTheFold_templateObject2());
const NavBtnWrapper = emotion_styled_browser_esm["default"].img((param)=>{
    let { show , left , right  } = param;
    return "\n  opacity: ".concat(show ? "1" : "0", ";\n  z-index: 549;\n  cursor: pointer;\n  transition: 0.1s;\n  position: absolute;\n  top: 39.5%;\n  ").concat(left ? "left: ".concat(left, ";") : "", "\n  ").concat(right ? "right: ".concat(right, ";") : "", "\n");
});
const RightBannerWrapper = emotion_styled_browser_esm["default"].div(AboveTheFold_templateObject3());
const renderMegaMenu = (menuItems)=>{
    if (!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length)) return;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
        menuItems: menuItems,
        type: "vertical"
    });
};
const AboveTheFold = (param)=>{
    let { menuItems , slideBanners =[] , topRightBanners =[] , horizontalFourBanners =[]  } = param;
    const sliderRef = (0,react.useRef)(null);
    const { 0: showNavBtns , 1: setShowNavBtns  } = (0,react.useState)(false);
    if (!menuItems.length && !slideBanners.length && !topRightBanners.length) return null;
    const isOnlySlideBanner = !menuItems.length && !topRightBanners.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AboveTheFold_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container_es/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                    justify: "space-around",
                    style: {
                        height: "".concat(sliderHeight, "px")
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                            span: 2,
                            paddingTop: "s16",
                            children: [
                                renderMegaMenu(menuItems),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBtnWrapper, {
                                    onMouseEnter: ()=>setShowNavBtns(true),
                                    show: showNavBtns,
                                    right: !isOnlySlideBanner ? "-46px" : undefined,
                                    left: isOnlySlideBanner ? "0" : undefined,
                                    onClick: ()=>{
                                        if (sliderRef.current) {
                                            sliderRef.current.glide.go("<");
                                        }
                                    },
                                    src: Previous,
                                    alt: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                flex: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBannerSlides, {
                                onMouseEnter: ()=>setShowNavBtns(true),
                                onMouseLeave: ()=>setShowNavBtns(false),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSlides.BannerSlides, {
                                    imageWidth: 1920,
                                    banners: slideBanners,
                                    sliderRef: sliderRef,
                                    prioritized: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                            span: 2,
                            paddingTop: "s16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBtnWrapper, {
                                    onMouseEnter: ()=>setShowNavBtns(true),
                                    show: showNavBtns,
                                    onClick: ()=>{
                                        if (sliderRef.current) {
                                            sliderRef.current.glide.go(">");
                                        }
                                    },
                                    left: !isOnlySlideBanner ? "-48px" : undefined,
                                    right: isOnlySlideBanner ? "0" : undefined,
                                    src: Next,
                                    alt: ""
                                }),
                                topRightBanners.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RightBannerWrapper, {
                                    children: topRightBanners.map((banner, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(AboveTheFold_EnhancedImage, {
                                            link: {
                                                href: banner.targetPath
                                            },
                                            tracking: (0,helper_es/* getTrackingData */.O5)({
                                                isTrackContent: true,
                                                regionName: "topRightBannerHomepage",
                                                contentName: banner.campaignName,
                                                index: index,
                                                target: banner.targetPath
                                            }),
                                            src: banner.image,
                                            borderRadius: 8,
                                            height: 220,
                                            objectFit: "cover",
                                            googleImageParams: {
                                                width: 300
                                            },
                                            hover: "zoom",
                                            alt: banner.campaignName || banner.description || "",
                                            lazy: false,
                                            fetchPriority: "high"
                                        }, index))
                                })
                            ]
                        })
                    ]
                }),
                !!horizontalFourBanners.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(FourBannerWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        span: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboveTheFold_FeaturedBanners, {
                            prioritized: true,
                            regionName: "bottomBanner",
                            banners: horizontalFourBanners.map((banner)=>{
                                return {
                                    src: banner.image,
                                    link: {
                                        href: banner.targetPath
                                    },
                                    name: banner.campaignName,
                                    lazy: false
                                };
                            })
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./modules/home/desktop/DefaultHome.tsx
function DefaultHome_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DefaultHome_templateObject() {
    const data = DefaultHome_taggedTemplateLiteral([
        "\n  top: 8px;\n  > div {\n    margin-top: 88px;\n  }\n"
    ]);
    DefaultHome_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










const PopupPromotion = dynamic_default()(()=>__webpack_require__.e(/* import() */ 62211).then(__webpack_require__.bind(__webpack_require__, 962211)).then((mod)=>mod.PopupPromotion), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(962211)
            ]
    }
});
const QuestionnairesModal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 31160).then(__webpack_require__.bind(__webpack_require__, 731160)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(731160)
            ]
    }
});
const StyledSideBanners = (0,emotion_styled_browser_esm["default"])(SideBanners)(DefaultHome_templateObject());
const DefaultHome = (param)=>{
    let { serverBlocks , menuItems =[] , ssrProducts ={} , inlineBanners  } = param;
    var ref;
    const { questionnairesUrl , megaMenuType ="vertical" , isBot , displayNewLayoutForPageBuilderV1 ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { slideBanners , topRightBanners , blocks , popupBanner , horizontalFourBanners ,  } = (0,useHomePage/* useHomePage */.J)(serverBlocks);
    const showPopupBanner = popupBanner && (popupBanner === null || popupBanner === void 0 ? void 0 : (ref = popupBanner.cookedData) === null || ref === void 0 ? void 0 : ref[0]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showPopupBanner && !isBot && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupPromotion, {
                banner: popupBanner.cookedData[0]
            }),
            displayNewLayoutForPageBuilderV1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewLayoutAboveTheFold, {
                menuItems: megaMenuType === "vertical" && (0,block/* findBlockByType */.yA)(types_es/* BlockType.MEGA_MENU */.kH.MEGA_MENU, blocks) ? menuItems : [],
                slideBanners: slideBanners,
                horizontalFourBanners: horizontalFourBanners,
                topRightBanners: topRightBanners
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AboveTheFold, {
                menuItems: megaMenuType === "vertical" && (0,block/* findBlockByType */.yA)(types_es/* BlockType.MEGA_MENU */.kH.MEGA_MENU, blocks) ? menuItems : [],
                slideBanners: slideBanners,
                topRightBanners: topRightBanners,
                horizontalFourBanners: horizontalFourBanners
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBanners, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoveryBlocks/* DiscoveryBlocks */.N, {
                blocks: blocks,
                ssrMapProducts: ssrProducts,
                inlineBanners: inlineBanners,
                pageTypeEnum: types_es/* PageTypeEnum.HOME */.DZ.HOME
            }),
            questionnairesUrl && !isBot && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionnairesModal, {})
        ]
    });
};


/***/ })

}]);